var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaludimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 130,
    viewBox: "0 0 152 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.539 126.722V78.7098C125.58 73.4706 136.319 65.8601 145.14 56.4925C149.796 51.5432 149.559 43.7564 144.61 39.0996C139.661 34.4434 131.874 34.6808 127.217 39.6296C120.589 46.6678 112.599 52.347 103.711 56.2031C95.1978 59.8964 85.7423 61.9461 75.7413 61.9461C65.7403 61.9461 56.2848 59.8964 47.7719 56.2031C38.8839 52.3475 30.8946 46.6683 24.2658 39.6296C19.6091 34.6803 11.8223 34.4429 6.87295 39.0996C1.92362 43.7564 1.68623 51.5432 6.34297 56.4925C15.1645 65.8601 25.9029 73.47 37.944 78.7098V126.722H113.539Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7419 3C92.0191 3 105.215 16.1954 105.215 32.4731C105.215 48.7502 92.0191 61.9461 75.7419 61.9461C59.4642 61.9461 46.2683 48.7502 46.2683 32.4731C46.2683 16.1959 59.4642 3 75.7419 3Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaludimg);
export default __webpack_public_path__ + "static/media/saludimg.695d50a308e07e0af7a1563c056093a3.svg";
export { ForwardRef as ReactComponent };